import { cn } from '@/lib/utils'

const statusColors: Record<string, string> = {
  active: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  pending: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  suspended: 'bg-red-500/10 text-red-400 border-red-500/20',
  deleting: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
  deleted: 'bg-slate-500/10 text-slate-500 border-slate-500/20',
  delivered: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  sent: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
  queued: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  bounced: 'bg-red-500/10 text-red-400 border-red-500/20',
  deferred: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  failed: 'bg-red-500/10 text-red-400 border-red-500/20',
  true: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  false: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
}

export function StatusBadge({ status, className }: { status: string | boolean; className?: string }) {
  const key = String(status).toLowerCase()
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium uppercase tracking-wide',
        statusColors[key] || 'bg-slate-500/10 text-slate-400 border-slate-500/20',
        className
      )}
    >
      {String(status)}
    </span>
  )
}
